export const initialValuesSession = {
	primaryNeed: '',
	personalIssue: '',
	personalIssueOther: '',
	issueRelation: '',
	issueRelationOther: '',
	relationshipChallenge: '',
	relationshipChallengeOther: '',
	communicationContext: '',
	communicationContextOther: '',
}
